// extracted by mini-css-extract-plugin
export default {"fieldDocRejected":"modalAbortDocuments_fieldDocRejected__IMpSM","contentButtons":"modalAbortDocuments_contentButtons__I+1cq"};